import {
  OPEN_CREDENTIAL_DIALOG,
  CLOSE_CREDENTIAL_DIALOG,
  FETCH_CREDENTIALS,
  SET_IS_LOADING_CREDENTIALS,
  SET_CREDENTIAL_DIALOG_MODE,
  SET_DELETE_CREDENTIAL_DIALOG_OPEN,
  SET_CREDENTIAL_MANAGEMENT_FILTER,
  SET_CREDENTIAL_MANAGEMENT_SHARE_USERS_MODAL_OPEN,
  SET_CREDENTIAL_MANAGEMENT_UNSHARE_USERS_MODAL_OPEN,
  SET_CREDENTIAL_MANAGEMENT_SHARE_AVAILABLE_USERS,
  SET_CREDENTIAL_MANAGEMENT_UNSHARE_AVAILABLE_USERS,
  SET_CREDENTIAL_MANAGEMENT_SHARE_SELECTED_USERS,
  SET_CREDENTIAL_MANAGEMENT_UNSHARE_SELECTED_USERS,
  SET_SELECTED_CREDENTIAL,
  CLEAR_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USERS,
  ADD_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER,
  REMOVE_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER
} from "redux/constants/portal";
import { SET_CREDENTIALS } from "../../constants/portal";

export const openCredentialDialog = () => ({
  type: OPEN_CREDENTIAL_DIALOG
});

export const closeCredentialDialog = () => ({
  type: CLOSE_CREDENTIAL_DIALOG
});

export const fetchCredentials = (tenant_id, auth0_id) => ({
  type: FETCH_CREDENTIALS,
  payload: { tenant_id, auth0_id }
});

export const setIsLoadingCredentials = (payload) => ({
  type: SET_IS_LOADING_CREDENTIALS,
  payload
});

export const setCredentialDialogMode = (payload) => ({
  type: SET_CREDENTIAL_DIALOG_MODE,
  payload
});

export const setDeleteCredentialDialogOpen = (payload) => ({
  type: SET_DELETE_CREDENTIAL_DIALOG_OPEN,
  payload
});

export const setCredentialManagementFilter = (payload) => ({
  type: SET_CREDENTIAL_MANAGEMENT_FILTER,
  payload
});

export const setCredentialManagementShareUsersModalOpen = (payload) => ({
  type: SET_CREDENTIAL_MANAGEMENT_SHARE_USERS_MODAL_OPEN,
  payload
});

export const setCredentialManagementUnshareUsersModalOpen = (payload) => ({
  type: SET_CREDENTIAL_MANAGEMENT_UNSHARE_USERS_MODAL_OPEN,
  payload
});

export const setCredentialManagementShareAvaiableUsers = (payload) => ({
  type: SET_CREDENTIAL_MANAGEMENT_SHARE_AVAILABLE_USERS,
  payload
});

export const setCredentialManagementUnshareAvailableUsers = (payload) => ({
  type: SET_CREDENTIAL_MANAGEMENT_UNSHARE_AVAILABLE_USERS,
  payload
});

export const setCredentialManagementShareSelectedUsers = (payload) => ({
  type: SET_CREDENTIAL_MANAGEMENT_SHARE_SELECTED_USERS,
  payload
});

export const setCredentialManagementUnshareSelectedUsers = (payload) => ({
  type: SET_CREDENTIAL_MANAGEMENT_UNSHARE_SELECTED_USERS,
  payload
});

export const setSelectedCredential = (payload) => ({
  type: SET_SELECTED_CREDENTIAL,
  payload
});

export const clearCredentialsManagementShareSelectedUsers = () => ({
  type: CLEAR_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USERS
});

export const addCredentialsManagementShareSelectedUser = (payload) => ({
  type: ADD_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER,
  payload
});

export const removeCredentialsManagementShareSelectedUser = (payload) => ({
  type: REMOVE_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER,
  payload
});

export const setCredentials = (payload) => ({
  type: SET_CREDENTIALS,
  payload
});
